<template>
  <div>
    <text-input :value="dossier.name" label="Name" ref="name"></text-input>
    <long-text-input :value="dossier.description" label="Kurzbeschreibung" ref="description"></long-text-input>
    <long-text-input :value="dossier.longDescription" label="Beschreibung" ref="longDescription"></long-text-input>
    <text-input :value="dossier.link" label="Externer Link" ref="link"></text-input>
    <entity-multiselect entity="tag" label="Tags" :value="tagIds" @input="changedTags" name="tags"></entity-multiselect>
    <div class="form-group">
      <label for="#chapter-position">Typ</label>
      <multiselect
        id="type"
        v-model="type"
        label="label"
        :options="typeOptions"
        :show-labels="false"
      ></multiselect>
    </div>
    <file-input v-model="image" label="Bild" type="image" />
    <div class="position-relative">
      <div class="form-group">
        <label for="input_available_from">Verfügbar ab</label>
        <date-picker v-model="availableFrom" :config="datePickerOptions" id="input_available_from"></date-picker>
      </div>
    </div>
    <div class="position-relative">
      <div class="form-group">
        <label for="input_available_from">Disclaimer Datum</label>
        <date-picker
          v-model="disclaimerDate"
          :config="datePickerOptions"
          id="input_disclaimer_date"
        ></date-picker>
      </div>
    </div>
    <div class="form-group">
        <label for="#position">Position</label>
        <input type="number" class="form-control" v-model="position" /> 
    </div>
    <button class="btn btn-primary" @click="save">Save</button>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["data"],
  data() {
    return {
      image: this.data.image,
      typeValue: this.data.type,
      typeOptions: [
        { value: 0, label: "Verbundsynthese" },
        { value: 1, label: "Externer Link" }
      ],
      availableFrom:
        this.data.synthesis.availableFrom &&
        this.data.synthesis.availableFrom.format("DD.MM.YYYY"),
      disclaimerDate:
        this.data.synthesis.disclaimerDate &&
        this.data.synthesis.disclaimerDate.format("DD.MM.YYYY"),
      tagIds: this.data.tagIds,
      position: this.data.position,
      datePickerOptions: {
        useCurrent: false,
        format: "DD.MM.YYYY"
      }
    };
  },
  computed: {
    type: {
      get() {
        return this.typeOptions.find(option => option.value === this.typeValue);
      },
      set(newType) {
        this.typeValue = newType.value;
      }
    },
    dossier() {
      return this.data;
    }
  },
  methods: {
    changedTags(value) {
      this.tagIds = value;
    },
    saveDossier() {
      const form = new FormData();

      if (this.image && this.image.id) {
        form.append("edit_dossier[image]", this.image.id);
      } else {
        form.append("edit_dossier[image]", "");
      }

      for (let id of this.tagIds) {
        form.append("edit_dossier[tags][]", id);
      }
      form.append('edit_dossier[position]', this.position);
      form.append("edit_dossier[type]", this.typeValue);
      form.set("edit_dossier[submit]", null);

      return axios.post(
        "/api/" +
          store.state.language +
          "/dossier/" +
          this.$route.params.dossierId +
          "/edit",
        form
      );
    },
    saveSynthesis() {
      let form = new FormData();
      const form_prefix = 'edit_synthesis';
      form.append(form_prefix + '[availableFrom]', this.availableFrom || '');
      form.append(form_prefix + '[disclaimerDate]', this.disclaimerDate || '');
      form.append(form_prefix + '[position]', 0);
      form.append(form_prefix + '[submit]', null);
      return axios
        .post('/api/' + store.state.language + '/synthesis/' + this.data.synthesisId + "/edit", form);
    },
    save() {
      Promise.all([
        this.$refs.name.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save(),
        this.$refs.link.save(),
        this.saveDossier(),
        this.saveSynthesis()
      ]).then(() => {
        this.$router.push({ name: "dossier-list" });
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/admin/dossier/General.vue